const adexstate = {
    adex_modes_list:{
        default:{
            C : 281,
            el : -70.6,
            del : 2,
            a : 4,
            vr : -54,
            gl : 30,
            vt : -50.4,
            tw : 144,
            b : 0.0805,
            T : 100,
            I : 20,
        },
        fs:{
                C : 200,
                el : -70,
                del : 2,
                a : 2,
                vr : -58,
                gl : 12,
                vt : -50,
                tw : 300,
                b : 60,
        },
        rs:{
                C : 281,
                el : -70.6,
                del :2,
                a : 4,
                vr : -54,
                gl : 30,
                vt : -50.4,
                tw : 144,
                b : 0.0805,
        },
        tc:{
            C : 130,
            el : -58,
            del : 2,
            a : 4,
            vr : -50,
            gl : 18,
            vt : -50,
            tw : 150,
            b : 120,
        },
        ib:{
            C : 104,
            el : -65,
            del : 5.5,
            a : -0.8,
            vr : -53,
            gl : 43,
            vt : -52,
            tw : 88,
            b : 65,
        },
        rz:{
                C : 200,
                el : -58,
                del : 2,
                a : 2,
                vr : -46,
                gl : 10,
                vt : -50,
                tw : 120,
                b : 100,
            },
        ch:{
            C : 200,
            el : -70,
            del : 0.8,
            a : 2,
            vr : -58,
            gl : 10,
            vt : -50,
            tw : 30,
            b : 0,
        }
    },
    adex_params:{
        C : 281,
        el : -70.6,
        del : 2,
        a : 4,
        vr : -54,
        gl : 30,
        vt : -50.4,
        tw : 144,
        b : 0.0805,
        T : 100,
        I : 20,
    },
    adex_param_list : [["C", 'gl'], ['el', 'vt'], ['del', 'tw'], ['b', 'vr'], ['a', ''] , ['T', "I"] ],
    adex_output : {
        V: [],
        w: [],
        T_steps: []
    }

}

export default adexstate;